import React from 'react';
import Show from '../Show/Show';
import { COLORS } from '../../config/designSystem/Colors';
import { Caption1Bold } from '../../config/designSystem/typography';
import { HeaderLeft } from './HeaderLeft';
import { HeaderRight } from './HeaderRight';
import { SIZE_TOP_BAR } from './HeaderSide';
import { SPACING } from '../../config/designSystem/Spacing';
import { StyleProp, View, ViewStyle } from 'react-native';


export type headerRightIconType = 'settings' | 'dots';
interface ActionMenuProps {
    onPressLeft: () => void,
    withHeaderRight?: boolean,
    onPressRight?: () => void,
    topPosition?: number,
    horizontalPosition?: number,
    headerRightIcon?: headerRightIconType,
    title?: string | null | undefined,
    style? : StyleProp<ViewStyle> | undefined;
    onboarding?: boolean;
    onLeaveOnboarding?: () => void;
    labelOnboarding?: string;
}

export const TopNavigation = ({ topPosition, horizontalPosition, onPressLeft,onPressRight, onboarding= false, labelOnboarding, onLeaveOnboarding, title, withHeaderRight, style, headerRightIcon }: ActionMenuProps) => {
  const TOP_POSITION = topPosition || SPACING['sp-16'];
  const HORIZONTAL_POSITION = horizontalPosition || SPACING['sp-16'];
  const titlePosition = SIZE_TOP_BAR;
  const marginTitle = SPACING['sp-16'];

  return (
    <View style={[ style, {zIndex: 10}]}>

      <HeaderLeft topPosition={TOP_POSITION} leftPosition={HORIZONTAL_POSITION} onPress={onPressLeft} />
      <Show when={!!title}>
        <View style={{height: SIZE_TOP_BAR,
          marginTop: TOP_POSITION,
          marginHorizontal: titlePosition + HORIZONTAL_POSITION + marginTitle,
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Caption1Bold color={COLORS.content.primary}>
            {title}
          </Caption1Bold>
        </View>
      </Show>
      <Show when={!!onPressRight && withHeaderRight }>

        <HeaderRight topPosition={TOP_POSITION}
          rightPosition={HORIZONTAL_POSITION}
          onPress={onPressRight as () => void}
          icon={headerRightIcon}
          onboarding={onboarding}
          labelOnboarding={labelOnboarding}
          onLeaveOnboarding={onLeaveOnboarding}
        />
      </Show>
    </View>

  );

};

